import { createSlice } from '@reduxjs/toolkit';
import { APIStatus } from '@application/enums/api-status';
import { createFormResponseAsync, getFormResponsesByEventIdAsync, getFormResponseByIdAsync, checkEmailExistsAsync } from './formResponseThunk';
const initialState = {
    status: APIStatus.IDLE
};
export const formResponseSlice = createSlice({
    name: 'formResponse',
    initialState,
    reducers: {
        clearFormResponse: (state) => {
            state.formResponse = undefined;
        },
        clearFormResponses: (state) => {
            state.formResponses = undefined;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(createFormResponseAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(createFormResponseAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.formResponse = action.payload;
        })
            .addCase(createFormResponseAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getFormResponsesByEventIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getFormResponsesByEventIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.formResponses = action.payload;
        })
            .addCase(getFormResponsesByEventIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getFormResponseByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getFormResponseByIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.formResponse = action.payload;
        })
            .addCase(getFormResponseByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(checkEmailExistsAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(checkEmailExistsAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.EmailAlreadyExist = action.payload.data;
        })
            .addCase(checkEmailExistsAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export const { clearFormResponse, clearFormResponses } = formResponseSlice.actions;
export default formResponseSlice.reducer;
